import { render, staticRenderFns } from "./VochersPromotion.vue?vue&type=template&id=0ba259fa&"
import script from "./VochersPromotion.vue?vue&type=script&lang=js&"
export * from "./VochersPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports